// #region MateraStatementResponse
export class MateraStatementResponse {
  statement: Statement = null;
}

export class Statement {
  period: Period = null;
  periodBalance: PeriodBalance = null;
  entries: Entry[] = null;
  statementCategory: StatementCategory = null;
}

export class StatementCategory {
  statementCode: EntryType = null;
  description: string = null;
}

export class Entry {
  entryDate: Date = null;
  historyDescription: string = null;
  historyCode: string = null;
  document: number = null;
  amount: number = null;
  entryType: EntryType = null;
}

export class Period {
  startDate: Date = null;
  endDate: Date = null;
}

export class PeriodBalance {
  balanceStartDate: DateBalance = null;
  balanceEndDate: DateBalance = null;
}

export class DateBalance {
  idBalanceType: number = null;
  balanceDescription: string = null;
  balance: number = null;
}

export enum EntryType {
  C,
  D,
  S,
}
// #endregion

// #region MateraTransferReleaseResponse
export class MateraTransferReleaseResponse {
  result: Result;
}

export class Result {
  transferencias: Transferencias[];
}

export class Transferencias {
  idLiqdc: number = null;
  data: Date = null;
  historico: number = null;
  valor: number = null;
  camaraDestinataria: string = null;
  codMsg: string = null;
  indEnviadoRecebido: string = null;
  contraparte: Contraparte = null;
  ticketId: number = null;
}

export class Contraparte {
  banco: number = null;
  agencia: number = null;
  conta: number = null;
  inscricao: number = null;
  tipoPessoa: string = null;
  nomeTitular: string = null;
}
// #endregion
